import { ChartDefinition, ChartKey, ChartRendererType } from '@frontend/chart/types';

import { SPOT_FILL_RATE_CHART_ENDPOINT } from '../transaction-chart-endpoints';

export const SPOT_FILL_RATE_LINE_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.SPOT_FILL_RATE_LINE,
    chartType: ChartRendererType.LINE,
    endpoint: SPOT_FILL_RATE_CHART_ENDPOINT,
    filters: []
};
